import { render, staticRenderFns } from "./FacturaUpdate.vue?vue&type=template&id=36feed94&scoped=true"
import script from "./FacturaUpdate.vue?vue&type=script&lang=js"
export * from "./FacturaUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36feed94",
  null
  
)

export default component.exports